// // import React, { useState } from "react";
// // import { ReactMediaRecorder } from "react-media-recorder";
// // import axios from "axios";
// // import { FaMicrophoneAlt, FaStopCircle } from "react-icons/fa";
// // import { IoCloseSharp, IoCloudUpload } from "react-icons/io5";

// // const AudioRecorder = ({ onClose }) => {
// //   const [blobUrl, setBlobUrl] = useState(null);
// //   const [audioBlob, setAudioBlob] = useState(null);
// //   const [transcript, setTranscript] = useState("");
// //   const [summary, setSummary] = useState("");

// //   // const uploadAudio = async () => {
// //   //   if (!audioBlob) return alert("No audio recorded!");

// //   //   const formData = new FormData();
// //   //   formData.append("audioFile", audioBlob, "recording.wav");

// //   //   try {
// //   //     const res = await axios.post("http://localhost:8080/upload-audio", formData, {
// //   //       headers: { "Content-Type": "multipart/form-data" },
// //   //     });
// //   //     setTranscript(res.data);
// //   //   } catch (err) {
// //   //     console.error(err);
// //   //     alert("Upload failed");
// //   //   }
// //   // };


// // // const uploadAudioToElevenLabs = async () => {
// // //   if (!audioBlob) return alert("No audio recorded!");

// // //   const formData = new FormData();
// // //   formData.append("model_id", "scribe_v1");       // ✅ Use correct model
// // //   formData.append("diarize", "true");             // ✅ Speaker separation
// // //   formData.append("file", audioBlob, "audio.wav"); // 👈 Your recorded audio

// // //   try {
// // //     const response = await fetch("https://api.elevenlabs.io/v1/speech-to-text", {
// // //       method: "POST",
// // //       headers: {
// // //         "xi-api-key": "sk_d064d0935e3491bf353b1c5f8fe442dd878faee67d4e014a",
// // //         // Do NOT expose in frontend for production
// // //       },
// // //       body: formData,
// // //     });

// // //     if (!response.ok) {
// // //       const error = await response.text();
// // //       console.error("Error:", error);
// // //       throw new Error("Transcription failed");
// // //     }

// // //     const result = await response.json();
// // //     console.log("ElevenLabs result:", result);

// // //     const formatted = result?.transcription?.segments
// // //       ?.map((s) => `${s.speaker || "Speaker"}: ${s.text}`)
// // //       .join("\n");

// // //     setTranscript(formatted);
// // //   } catch (err) {
// // //     console.error("Upload error:", err);
// // //     alert("Upload failed or invalid API key.");
// // //   }
// // // };

// // const summarizeTranscript = async () => {
// //   if (!transcript) return alert("Transcript is empty");

// //   // Try browser's native Summarizer (only in Chrome 138+)
// //   if ("Summarizer" in window) {
// //     try {
// //       const result = await window.Summarizer.summarize(transcript, {
// //         type: "paragraph",
// //       });
// //       setSummary(result?.text || "No summary generated.");
// //     } catch (e) {
// //       console.error("Browser summarizer failed, fallback:", e);
// //       fallbackSummarize();
// //     }
// //   } else {
// //     // Fallback summarizer (basic keyword-based)
// //     fallbackSummarize();
// //   }
// // };

// // const fallbackSummarize = () => {
// //   const lines = transcript.split("\n");
// //   const importantLines = lines.filter(line =>
// //     /(cold|fever|throat|nose|congestion|symptom|recommend|advice)/i.test(line)
// //   );
// //   const fallbackText =
// //     "Summary:\n" +
// //     importantLines.map(line => `- ${line.split(":")[1]?.trim()}`).join("\n");

// //   setSummary(fallbackText || "No important content found.");
// // };

// // const uploadAudioToElevenLabs = async () => {
// //   if (!audioBlob) return alert("No audio recorded!");

// //   const formData = new FormData();
// //   formData.append("model_id", "scribe_v1");       // Required model
// //   formData.append("diarize", "true");             // Enable speaker separation
// //   formData.append("file", audioBlob, "audio.wav");

// //   try {
// //     const response = await fetch("https://api.elevenlabs.io/v1/speech-to-text", {
// //       method: "POST",
// //       headers: {
// //         "xi-api-key": "sk_d064d0935e3491bf353b1c5f8fe442dd878faee67d4e014a",
// //         // DO NOT expose this key in production
// //       },
// //       body: formData,
// //     });

// //     if (!response.ok) {
// //       const error = await response.text();
// //       console.error("Error:", error);
// //       throw new Error("Transcription failed");
// //     }

// //     const result = await response.json();
// //     console.log("ElevenLabs result:", result);

// //     // Group words by speaker
// //     const groupBySpeaker = (wordsArray) => {
// //       const grouped = [];
// //       let currentSpeaker = null;
// //       let currentLine = "";

// //       for (const wordObj of wordsArray) {
// //         const text = wordObj.text || "";
// //         const speaker = wordObj.speaker_id;

// //         if (wordObj.type === "spacing") {
// //           currentLine += text;
// //           continue;
// //         }

// //         if (speaker !== currentSpeaker) {
// //           if (currentLine.trim() !== "") {
// //             grouped.push({ speaker: currentSpeaker, line: currentLine.trim() });
// //           }

// //           currentSpeaker = speaker;
// //           currentLine = text + " ";
// //         } else {
// //           currentLine += text + " ";
// //         }
// //       }

// //       if (currentLine.trim() !== "") {
// //         grouped.push({ speaker: currentSpeaker, line: currentLine.trim() });
// //       }

// //       return grouped;
// //     };

// //     const grouped = groupBySpeaker(result.words);

// //     const transcriptText = grouped
// //       .map((entry) => {
// //         // You can change this mapping if needed
// //         const speakerLabel =
// //           entry.speaker === "speaker_0" ? "Patient" : "Doctor";
// //         return `${speakerLabel}: ${entry.line}`;
// //       })
// //       .join("\n");

// //     setTranscript(transcriptText);
// //   } catch (err) {
// //     console.error("Upload error:", err);
// //     alert("Upload failed or invalid API key.");
// //   }
// // };


// //   return (
// //     <div >
// //       <ReactMediaRecorder
// //         audio
// //         onStop={(blobUrl, blob) => {
// //           setBlobUrl(blobUrl);
// //           setAudioBlob(blob);
// //         }}
// //         render={({ status, startRecording, stopRecording }) => (
// //           <>
// //           <div>
// //             <div>
// //             <span>Status: {status}</span>
// //             </div>
// //             <div className="flex gap-3">
// //             <button className="text-white p-1 text-xs rounded-md flex items-center gap-1" onClick={startRecording}><FaMicrophoneAlt /> Start</button>
// //             <button className="text-white p-1 text-xs rounded-md flex items-center gap-1" onClick={stopRecording}><FaStopCircle /> Stop</button>
// //             </div>
// //             {blobUrl && <audio src={blobUrl} controls />}
// //             </div>
// //             <div className="flex gap-3 mt-2">
// //             <button className="text-white p-1 text-xs rounded-md flex gap-1 items-center" onClick={uploadAudioToElevenLabs}><IoCloudUpload /> Upload & Transcribe</button>
// //             <button className="text-white p-1 text-xs rounded-md flex gap-1 items-center" onClick={onClose}><IoCloseSharp /> Close</button>
// //             </div>
// //           </>
// //         )}
// //       />
// // {/* 
// //       {transcript && (
// //         <div>
// //           <h4>📝 Transcript:</h4>
// //           <pre>{transcript}</pre>
// //         </div>
// //       )} */}
// //       {transcript && (
// //   <div>
// //     <h4>📝 Transcript:</h4>
// //     <pre>{transcript}</pre>
// //     <button
// //       className="text-white p-1 text-xs rounded-md bg-blue-700 mt-2"
// //       onClick={summarizeTranscript}
// //     >
// //       📄 Generate Summary
// //     </button>
// //   </div>
// // )}

// // {summary && (
// //   <div className="mt-2">
// //     <h4>🧠 Summary:</h4>
// //     <pre>{summary}</pre>
// //   </div>
// // )}

// //     </div>
// //   );
// // };

// // export default AudioRecorder;

// import React, { useState } from "react";
// import { ReactMediaRecorder } from "react-media-recorder-2";
// import { FaMicrophoneAlt, FaStopCircle } from "react-icons/fa";
// import { IoCloseSharp, IoCloudUpload } from "react-icons/io5";

// const AudioRecorder = ({ onClose }) => {
//   const [blobUrl, setBlobUrl] = useState(null);
//   const [audioBlob, setAudioBlob] = useState(null);
//   const [transcript, setTranscript] = useState("");
//   const [summary, setSummary] = useState("");
//   const [loading, setLoading] = useState(false);

//   const ASSEMBLY_API_KEY = "47b408f832f94fa5ba5f11b8a78488f8"; 

//   const uploadToAssemblyAI = async () => {
//     if (!audioBlob) return alert("No audio recorded!");
//     setLoading(true);

//     try {
//       // 1️⃣ Upload audio
//       const uploadRes = await fetch("https://api.assemblyai.com/v2/upload", {
//         method: "POST",
//         headers: { authorization: ASSEMBLY_API_KEY },
//         body: audioBlob,
//       });
//       const uploadData = await uploadRes.json();
//       const audioUrl = uploadData.upload_url;

//       // 2️⃣ Request transcription + summarization
//       const transcriptRes = await fetch("https://api.assemblyai.com/v2/transcript", {
//         method: "POST",
//         headers: {
//           "authorization": ASSEMBLY_API_KEY,
//           "content-type": "application/json",
//         },
//         body: JSON.stringify({
//           audio_url: audioUrl,
//           speaker_labels: true,
//           summarization: true,
//           summary_model: "informative",
//           summary_type: "paragraph", // "paragraph" | "bullets" | "headline"
//           auto_chapters: false,
//         }),
//       });

//       const transcriptData = await transcriptRes.json();
//       const transcriptId = transcriptData.id;

//       // 3️⃣ Poll for transcript status
//       let finalData = null;
//       let completed = false;

//       while (!completed) {
//         const pollingRes = await fetch(
//           `https://api.assemblyai.com/v2/transcript/${transcriptId}`,
//           { headers: { authorization: ASSEMBLY_API_KEY } }
//         );

//         finalData = await pollingRes.json();

//         if (finalData.status === "completed") {
//           completed = true;

//           // ✅ Speaker-separated transcript (utterances if available)
//           const formattedTranscript = finalData.utterances
//             ? finalData.utterances
//                 .map((u) => `Speaker ${u.speaker}: ${u.text}`)
//                 .join("\n")
//             : finalData.text;

//           setTranscript(formattedTranscript);

//           // ✅ Summary from AssemblyAI
//           setSummary(finalData.summary || "No summary provided.");
//         } else if (finalData.status === "error") {
//           throw new Error(finalData.error);
//         } else {
//           await new Promise((r) => setTimeout(r, 3000)); // wait 3s
//         }
//       }
//     } catch (err) {
//       console.error("Error uploading to AssemblyAI:", err);
//       alert("Something went wrong with AssemblyAI.");
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <div>
//       <ReactMediaRecorder
//         audio
//         onStop={(blobUrl, blob) => {
//           setBlobUrl(blobUrl);
//           setAudioBlob(blob);
//         }}
//         render={({ status, startRecording, stopRecording }) => (
//           <>
//             <div>
//               <span>Status: {status}</span>
//               <div className="flex gap-3">
//                 <button
//                   className="text-white p-1 text-xs rounded-md flex items-center gap-1"
//                   onClick={startRecording}
//                 >
//                   <FaMicrophoneAlt /> Start
//                 </button>
//                 <button
//                   className="text-white p-1 text-xs rounded-md flex items-center gap-1"
//                   onClick={stopRecording}
//                 >
//                   <FaStopCircle /> Stop
//                 </button>
//               </div>
//               {blobUrl && <audio src={blobUrl} controls />}
//             </div>

//             <div className="flex gap-3 mt-2">
//               <button
//                 className="text-white p-1 text-xs rounded-md flex gap-1 items-center bg-blue-700"
//                 onClick={uploadToAssemblyAI}
//                 disabled={loading}
//               >
//                 <IoCloudUpload /> {loading ? "Processing..." : "Upload & Transcribe"}
//               </button>
//               <button
//                 className="text-white p-1 text-xs rounded-md flex gap-1 items-center"
//                 onClick={onClose}
//               >
//                 <IoCloseSharp /> Close
//               </button>
//             </div>
//           </>
//         )}
//       />

//       {transcript && (
//         <div className="mt-4">
//           <h4>📝 Transcript:</h4>
//           <pre>{transcript}</pre>
//         </div>
//       )}

//       {summary && (
//         <div className="mt-4">
//           <h4>🧠 Summary:</h4>
//           <p>{summary}</p>
//         </div>
//       )}
//     </div>
//   );
// };

// export default AudioRecorder;


import React, { useState, useRef, forwardRef, useImperativeHandle } from "react";
import { ReactMediaRecorder } from "react-media-recorder-2";
import { FaMicrophoneAlt, FaPauseCircle, FaPlay, FaRegStopCircle } from "react-icons/fa";
import { IoCloseSharp } from "react-icons/io5";
import AudioService from "../../../Services/AudioService";

const AudioRecorder = forwardRef(({ onClose, appointmentDetails }, ref) => {
  const [loading, setLoading] = useState(false);
  const [isRecording, setIsRecording] = useState(false);
  const [isPaused, setIsPaused] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [consentGiven, setConsentGiven] = useState(false);
 const hasUploadedRef = useRef(false);
  const recorderControls = useRef(null);

  // ✅ Expose stopRecording to parent (for End button)
  useImperativeHandle(ref, () => ({
    stopRecordingFromParent: () => {
      if (recorderControls.current && isRecording) {
        console.log("🛑 Stopping recording automatically from parent...");
        recorderControls.current.stopRecording();
      }
    },
  }));

  // ✅ Upload & then fetch transcript
  // const autoUpload = async (blob) => {
  //   if (!appointmentDetails?.appointmentId) {
  //     alert("Missing appointment details");
  //     return;
  //   }

  //   try {
  //     setLoading(true);

  //     const file = new File([blob], `${appointmentDetails.appointmentId}.mp3`, {
  //       type: "audio/mpeg",
  //     });

  //     const formData = new FormData();
  //     formData.append("audioFile", file);
  //     formData.append("patientId", appointmentDetails.patientId);
  //     formData.append("userId", appointmentDetails.userId);
  //     formData.append("appointmentId", appointmentDetails.appointmentId);

  //     console.log("🎙️ Uploading audio...");
  //     const uploadRes = await AudioService.AudioUpload(formData);
  //     console.log("✅ Upload success:", uploadRes.data);
  //   } catch (error) {
  //     console.error("❌ Upload failed:", error);
  //     alert("Audio upload failed.");
  //   } finally {
  //     setLoading(false);
  //     setIsRecording(false);
  //   }
  // };
// const autoUpload = async (blob) => {
//   if (hasUploaded) {
//     console.warn("⚠️ Duplicate stop detected — skipping upload.");
//     return;
//   }
//   setHasUploaded(true); // ✅ Prevent further uploads

//   if (!appointmentDetails?.appointmentId) {
//     alert("Missing appointment details");
//     return;
//   }

//   try {
//     setLoading(true);

//     const file = new File([blob], `${appointmentDetails.appointmentId}.mp3`, {
//       type: "audio/mpeg",
//     });

//     const formData = new FormData();
//     formData.append("audioFile", file);
//     formData.append("patientId", appointmentDetails.patientId);
//     formData.append("userId", appointmentDetails.userId);
//     formData.append("appointmentId", appointmentDetails.appointmentId);

//     console.log("🎙️ Uploading audio...");
//     const uploadRes = await AudioService.AudioUpload(formData);
//     console.log("✅ Upload success:", uploadRes.data);
//   } catch (error) {
//     console.error("❌ Upload failed:", error);
//     alert("Audio upload failed.");
//   } finally {
//     setLoading(false);
//     setIsRecording(false);
//   }
// };
  
const autoUpload = async (blob) => {
  if (hasUploadedRef.current) {
    console.warn("⚠️ Duplicate stop detected — skipping upload.");
    return;
  }
  hasUploadedRef.current = true; // ✅ Prevent duplicate uploads instantly

  if (!appointmentDetails?.appointmentId) {
    alert("Missing appointment details");
    return;
  }

  try {
    setLoading(true);

    const file = new File([blob], `${appointmentDetails.appointmentId}.mp3`, {
      type: "audio/mpeg",
    });

    const formData = new FormData();
    formData.append("audioFile", file);
    formData.append("patientId", appointmentDetails.patientId);
    formData.append("userId", appointmentDetails.userId);
    formData.append("appointmentId", appointmentDetails.appointmentId);

    console.log("🎙️ Uploading audio...",formData);

    const uploadRes = await AudioService.AudioUpload(formData);
    console.log("✅ Upload success:", uploadRes.data);
  } catch (error) {
    console.error("❌ Upload failed:", error);
    alert("Audio upload failed.");
  } finally {
    setLoading(false);
    setIsRecording(false);
  }
};

return (
    <div className="relative">
      {/* 🎙️ Floating mic button */}
      <button
        className="bg-red-600 text-white rounded-full p-2 shadow-md hover:bg-red-700 transition flex items-center justify-center text-xl"
        onClick={() => setShowModal(true)}
      >
        <FaRegStopCircle />
      </button>

      <ReactMediaRecorder
        audio
        onStop={(url, blob) => {
          console.log("🎧 Recording stopped, uploading...");
          autoUpload(blob);
        }}
        render={({ status, startRecording, pauseRecording, resumeRecording, stopRecording }) => {
          if (!recorderControls.current) {
            recorderControls.current = { startRecording, pauseRecording, resumeRecording, stopRecording };
          }
          return (
            <>
              {/* 🎛️ Recording Modal */}
              {showModal && (
                <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
                  <div className="bg-white rounded-lg shadow-lg p-6 w-96">
                    <h2 className="text-lg font-semibold mb-3 text-center">
                      Record Consultation Summary
                    </h2>

                    {/* ✅ Consent */}
                    <label className="flex items-center cursor-pointer gap-2 mb-4">
                      <input
                        type="checkbox"
                        checked={consentGiven}
                        onChange={(e) => setConsentGiven(e.target.checked)}
                      />
                      <span>I consent to record this consultation summary.</span>
                    </label>

                    <div className="text-sm text-gray-600 mb-2">Status: {status}</div>

                    {/* 🎛️ Controls (NO STOP BUTTON) */}
                    <div className="flex justify-center gap-3">
                      {!isRecording ? (
                        <button
                          disabled={!consentGiven}
                          className={`text-white p-2 text-xs rounded-md flex items-center gap-1 ${consentGiven ? "bg-green-700" : "bg-gray-400"
                            }`}
                          onClick={() => {
                             hasUploadedRef.current = false; 
                            startRecording();
                            setIsRecording(true);
                            setIsPaused(false);
                            setShowModal(false);
                          }}
                        >
                          <FaMicrophoneAlt /> Start
                        </button>
                      ) : isPaused ? (
                        <button
                          className="text-white p-2 text-xs rounded-md flex items-center gap-1 bg-green-700"
                          onClick={() => {
                            resumeRecording();
                            setIsPaused(false);
                          }}
                        >
                          <FaPlay /> Resume
                        </button>
                      ) : (
                        <button
                          className="text-white p-2 text-xs rounded-md flex items-center gap-1 bg-yellow-600"
                          onClick={() => {
                            pauseRecording();
                            setIsPaused(true);
                          }}
                        >
                          <FaPauseCircle /> Pause
                        </button>
                      )}
                    </div>

                    <div className="flex justify-center mt-4">
                      <button
                        className="text-gray-700 border px-2 py-1 text-xs rounded-md flex gap-1 items-center"
                        onClick={() => {
                          setShowModal(false);
                          if (onClose) onClose();
                        }}
                      >
                        <IoCloseSharp /> Close
                      </button>
                    </div>
                  </div>
                </div>
              )}
            </>
          );
        }}
      />
    </div>
  );
});

export default AudioRecorder;

